import React from 'react';
import { disciplines } from '../data/hero';
import { phases, tools } from '../data/system';
export function SystemOverview() {
  return <section aria-label="Panoramica del sistema" className="bg-navy text-white" data-id="element-279" data-mp="18v0mymbbl32b">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "22px"
    }} data-id="element-280" data-mp="1mlchsszahfx5">
        <div className="mx-auto max-w-3xl text-center" data-id="element-281" data-mp="1hocm9c02fvka">
          <h2 className="font-display text-3xl font-extrabold uppercase leading-none sm:text-5xl" data-id="element-282" data-mp="txgpe0gr6a66">
            Il Sistema Triathlon Full Distance™
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-283" data-mp="pyrc07vpssmj">
            Un sistema completo per chi non vuole più mettere insieme allenamenti casuali, consigli
            scollegati e informazioni trovate in decine di fonti diverse.
          </p>
          <p className="mt-5 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-284" data-mp="2f9rsj3be1c2o">
            {disciplines.map((d, i) => <React.Fragment key={d} data-id="element-285" data-mp="235ch9pjkjqpi" data-mpi={i}>
                {i > 0 && <span className="text-aqua" aria-hidden="true" data-id="element-286" data-mp="238qiuvkervvw">·</span>}
                <span data-id="element-287" data-mp="283w4rudt9ajz">{d}</span>
              </React.Fragment>)}
          </p>
          <p className="mt-3 text-sm text-white/50" data-id="element-288" data-mp="2d5lglc8uxs94">Tutto ciò che ti serve in un unico pacchetto completo</p>
        </div>

        <p className="mt-12 text-center text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-289" data-mp="2i34wshp48f3p">
          Un sistema · Sei fasi · Quattro strumenti complementari
        </p>

        <ol className="relative mt-8 grid gap-5 lg:grid-cols-6 lg:gap-4" data-id="element-290" data-mp="1pg0vont58kx7">
          <span aria-hidden="true" className="absolute bottom-3 left-[17px] top-3 w-px bg-electric/50 lg:bottom-auto lg:left-[18px] lg:right-[18px] lg:top-[17px] lg:h-px lg:w-auto" data-id="element-291" data-mp="1udiwfqx0btu4" />
          {phases.map((p, i) => <li key={p.n} className="relative flex items-start gap-4 text-left lg:flex-col lg:gap-3" data-id="element-292" data-mp="11pwuso7caz9w" data-mpi={i}>
              <span className={i === phases.length - 1 ? 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-electric font-display text-sm font-bold text-white' : 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-electric bg-navy font-display text-sm font-bold text-white'} data-id="element-293" data-mp="16nokrcofcbbg">
                {p.n}
              </span>
              <div data-id="element-294" data-mp="13es9pouydj7l">
                <p className="font-display text-xl font-bold uppercase leading-tight" data-id="element-295" data-mp="13e8re71e4st1">{p.name}</p>
                <p className="mt-0.5 text-sm leading-snug text-white/60" data-id="element-296" data-mp="fo4nrzo7ct21">{p.short}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12 border-t border-white/10 pt-8" data-id="element-297" data-mp="areatl7p2dku">
          <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-white/50" data-id="element-298" data-mp="pndorchhj7xw">
            In più, 4 strumenti pratici per la tua preparazione
          </p>
          <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-6 lg:grid-cols-4" data-id="element-299" data-mp="21294z2vs5hgk">
            {tools.map(({
            verb,
            name,
            icon: Icon
          }) => <li key={verb} className="flex items-start gap-3" data-id="element-300" data-mp="1w2o1cf5o0kxi">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-aqua" aria-hidden="true" data-id="element-301" data-mp="23mfhhyygmg8q" />
                <div data-id="element-302" data-mp="28mb9t0xsoj8g">
                  <p className="font-display text-lg font-bold uppercase leading-none text-white" data-id="element-303" data-mp="28mtdgimsdzqe">{verb}</p>
                  <p className="mt-1 text-xs leading-snug text-white/60" data-id="element-304" data-mp="1unbwgpfqfqrl">{name}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}